<template>
  <van-list
    v-model="loading"
    :finished="finished"
    finished-text="没有更多了"
    @load="onLoad"
  >
    <!-- <van-nav-bar
        title="屏蔽公司"
        left-arrow
        fixed
        placeholder
        @click-left="onClickLeft">
      </van-nav-bar> -->
    <div class="title-sm">已屏蔽公司（共{{ blackList.length }}个）</div>
    <ul class="companies">
      <li v-for="item in blackList" :key="item.index">
        <div class="name" @click="companyDetail(item.id)">
          <!-- <span v-if="item.enterpriseLogoUrl" > -->
          <img v-if="item.enterpriseLogoUrl" :src="item.enterpriseLogoUrl" />
          <img v-else src="../../../../assets/img/ent_deft.png" />
          <!-- </span> -->
          <!-- <span v-else>
              <img src="~@/assets/images/fail.png" alt="">
            </span> -->
          <h2>{{ item.enterpriseName }}</h2>
        </div>
        <button @click="shieldCompany(item.id)">取消屏蔽</button>
      </li>
    </ul>
  </van-list>
</template>

<script>
export default {
  name: "shieldCompanies",
  data() {
    return {
      loading: false,
      finished: false,
      blackList: [],
      current: 1
    };
  },
  // mounted(){
  //    this.$nextTick(() => {
  //      this.onload()
  //    })
  // },
  methods: {
    onLoad() {
      this.module.api.blackEntList({
        data: {
          current: this.current,
          size: 10
        },
        success: res => {
          this.blackList = Array.from(new Set(res.records, this.blackList));
          res.pages > this.current && this.current++;
          this.loading = false;
          if (this.blackList.length >= res.total) {
            this.finished = true;
          }
        }
      });
    },
    shieldCompany(wdJobEnterpriseId) {
      this.module.api.entShield({
        params: { wdJobEnterpriseId },
        success: res => {
          if (res) {
            this.toast("操作成功");
            this.blackList = this.blackList.filter(
              (item, index) => item.id !== wdJobEnterpriseId
            );
            this.onLoad();
          }
        }
      });
    },
    companyDetail(id) {
      this.$router.push({ name: "companyDetail", query: { id } });
    },
    onClickLeft() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="less" scoped>
.title-sm {
  padding: 16px 20px;
  color: #515255;
  border-bottom: 1px solid #eee;
}
.companies {
  li {
    display: flex;
    align-items: center;
    margin: 0 16px;
    padding: 16px 0;
    justify-content: space-between;
    border-bottom: 1px solid #eee;
    .name {
      display: flex;
      align-items: center;
      img {
        width: 50px;
        height: 50px;
        border-radius: 10px;
        object-fit: cover;
      }
      h2 {
        font-size: 14px;
        color: #3a3a3a;
        margin-left: 10px;
        font-weight: bold;
      }
    }
    button {
      padding: 4px 12px;
      background: #e4ebfb;
      color: #4469e3;
      border-radius: 50px;
      border: 1px solid #4469e3;
      font-size: 12px;
    }
  }
}
</style>
